export const LOAD_APP_THEME = 'app/LOAD_APP_THEME';
export const SET_APP_THEME = 'app/SET_APP_THEME';
export const SET_LOADING_APP_THEME = 'app/SET_LOADING_APP_THEME';
export const SEND_INTERCOM_MESSAGE = 'SEND_INTERCOM_MESSAGE';
export const SET_OPEN_DISABLED_COURSE_MODAL = 'mainLayout/SET_OPEN_DISABLED_COURSE_MODAL';
export const SET_SUBMIT_OPEN_DISABLED_COURSE_MODAL =
  'mainLayout/SET_SUBMIT_OPEN_DISABLED_COURSE_MODAL';
